// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
/**
 * Thin wrappers around window.location for testability.
 * jsdom 26+ makes window.location non-configurable, so tests
 * mock these functions instead of replacing window.location.
 */

export function getLocationSearch(): string {
  return window.location.search;
}

export function getLocationPathname(): string {
  return window.location.pathname;
}

export function navigateTo(url: string): void {
  window.location.assign(url);
}
